import { deserialize } from 'cerialize'
import moment from 'moment'
import { DATE_FORMAT, DatePeriod } from 'Src/constants/Global'
import { DefaultPeriod, ProductPackagesType } from 'Pages/dashboard'

export class DashboardParams {
	@deserialize public period?: DatePeriod = DefaultPeriod
	@deserialize public date_at: string = moment().startOf(DefaultPeriod).format(DATE_FORMAT)
	@deserialize public date_to: string = moment().format(DATE_FORMAT)
	@deserialize public products_group?: ProductPackagesType = ProductPackagesType.ALL
	@deserialize public products_ids?: number[]
}

export type DashboardParamsApi = {
	period?: DatePeriod
	partner_id?: number
	products_group?: Exclude<ProductPackagesType, 'all'>
	products_ids?: DashboardParams['products_ids']
	from?: DashboardParams['date_at']
	to?: DashboardParams['date_to']
	full?: boolean
	is_current_period?: boolean
}
